import Dictionary from '@inqool/uas-web-core/es/components/app/Dictionary';
import { breadcrumbs } from '@inqool/uas-web-core/es/utils';
import { compose, withProps, onlyUpdateForKeys, setDisplayName } from 'recompose';
import { withRouter } from 'react-router-dom';

import { withClassname } from '@components/hoc/withClassname';

import { RequestsForm } from '@modules/requests/requestsForm';
import { withAdditionalProps } from '@components/hoc/withAdditionalProps';
import { ActionBar } from '@modules/requests/requestsGridButtons';
import { withColumns } from '@components/hoc/withColumns';
import { Agenda } from '@modules/columnSettings/_columnSettingsEnums';

export const requestsUrl = '/metropolis/api/owa/employee/requests';
export const requestsLabel = 'Žádosti o přiřazení předmětů';
export const requestsPath = '/warehouses/requests';
export const requestsGridName = 'requestsGrid';

const filters = [{ field: 'requestState.id', operation: 'EQ', value: 'WAITING' }];

export const RequestsGrid = compose(
  withRouter,
  setDisplayName(requestsGridName),
  onlyUpdateForKeys(['url', 'location']),
  breadcrumbs([{ label: requestsLabel }]),
  withColumns(Agenda.REQUESTS),
  withProps(({ columns }) => ({
    name: requestsGridName,
    url: requestsUrl,
    Form: RequestsForm,
    dialog: false,
    gridProps: {
      columns,
      filters,
      defaultFilter: filters,
      filterRow: true,
      showCheckboxes: true,
      deleting: false,
      filtering: true,
      locale: 'cz',
      adding: false,
      ActionBar,
      pageSize: 50,
      version: 3
    }
  })),
  withAdditionalProps,
  withClassname({ className: 'mp-grid' })
)(Dictionary);



// WEBPACK FOOTER //
// ./src/modules/requests/requestsGrid.tsx